import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from '../../../_services/admin.service';

@Component({
  selector: 'app-fact-sub-topic-index',
  templateUrl: './fact-sub-topic-index.component.html',
  styleUrls: ['./fact-sub-topic-index.component.css']
})
export class FactSubTopicIndexComponent implements OnInit {
 factList =[]
  subTopicName:string=""
  topicName:string=""
  levels=[]
  dtOptions: DataTables.Settings = {};
  loading = false
  server_subtopic_id:number=0

  constructor(private adminService:AdminService, private activeRoute:ActivatedRoute) { }

  ngOnInit(): void {
    this.loading=true
    this.dtOptions = {
      pagingType: 'full_numbers'
     }
     this.activeRoute.params.subscribe(
       myParams=>{
         this.server_subtopic_id=myParams['server_subtopic_id']
         this.loadFacts()
       }
     )
  }

  loadFacts(){
    this.adminService.getFactsBySubtopic(this.server_subtopic_id).subscribe(
      x=>{

        this.factList=x['facts']
        this.loading=false
        this.subTopicName=x['name']
        this.topicName = x['topicName']
        this.levels=x['levels']
      }
    )
  }
  removeFact(id:number){
    this.adminService.removeFactFromSubtopic(id,this.server_subtopic_id).subscribe(
      x=>{

        this.subTopicName = x['name']
        this.loading=false
      }
    )
  }

}
